import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import clsx from 'clsx';

interface MicroLabelProps {
  icon?: LucideIcon;
  /**
   * `section` heads a block inside the brand card; `eyebrow` heads a whole section; `field`
   * names a single value. The design gives each its own size, tracking and weight, and 11px
   * has no step on the type scale.
   */
  variant?: 'section' | 'eyebrow' | 'field' | 'strong';
  children: ReactNode;
}

const VARIANTS = {
  section: 'gap-[7px] text-[11px] font-medium tracking-[0.06em] text-foreground',
  eyebrow: 'gap-xs text-body-sm font-medium tracking-[0.05em] text-muted-foreground',
  field: 'gap-[7px] text-[11px] font-medium tracking-[0.04em] text-muted-foreground',
  strong: 'gap-[7px] text-[11px] font-bold tracking-[0.06em] text-muted-foreground',
} as const;

/** The uppercase micro-heading the design uses above every block on this page. */
export const MicroLabel = ({ icon: Icon, variant = 'section', children }: MicroLabelProps) => (
  <span className={clsx('flex items-center uppercase', VARIANTS[variant])}>
    {Icon && <Icon className="size-3.5 shrink-0" />}
    {children}
  </span>
);
